export interface OfferErrorKey {
  supplierId: string
  storeCode: number
  productCode: number
}

export interface OfferErrorContext {
  key: OfferErrorKey
  route: string[]
}

export const OFFER_VALIDATION_ERROR_TYPES = [
  'LEFTOVER_VALIDATION',
  'ROUTE_VALIDATION',
  'PRICE_VALIDATION',
] as const

export type OfferValidationErrorType =
  (typeof OFFER_VALIDATION_ERROR_TYPES)[number]

export interface ValidationError {
  field: string
  rejectedValue?: unknown
  message: string
  context: OfferErrorContext
}

export interface ValidationErrorResponse {
  status: number
  type: OfferValidationErrorType
  message: string
  details: ValidationError[]
  traceId?: string
}

export interface ApiErrorDetail {
  message?: string
  field?: string
  rejectedValue?: unknown
  context?: OfferErrorContext
}

export interface ApiErrorResponseData {
  message?: string
  title?: string
  detail?: string
  details?: ApiErrorDetail[]
  traceId?: string
}
